import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiResponse } from '@app/_models';
import { AlertService } from '@app/_services';
import { PropertyService } from '@app/_components/property';
import { ReportService } from '@app/_components/report/report.service';

@Injectable({
	providedIn: 'root'
})

@Injectable()
export class PropertyListResolver  {

	constructor(
		private router: Router,
		private reportService: ReportService,
		private alertService: AlertService) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Observable<ApiResponse>
	{
		return this.reportService.propertySummaryList();
	}
}
